<!-- Service note -->
<template>
  <div class="cv-rl-item cv-rl-note">
    <div>
      <div class="cv-rl-item-title">
        <zlr-title title="Service note"></zlr-title>
      </div>
      <div>
        <div class="cv-rl-note-item">
          <span>{{moduleName}} (Max time)</span>
          <span>{{scheduleTime.maxTime}}mins (If the mentee has not confirmed the number of programs, the max time is 0)</span>
        </div>
        <div class="cv-rl-note-item">
          <span>{{moduleName}} (Used time)</span>
          <span>{{scheduleTime.usedTime}}mins</span>
        </div>
        <div class="cv-rl-note-item">
          <span>{{moduleName}} (Remaining time)</span>
          <span>{{scheduleTime.remainTime > 0 ? scheduleTime.remainTime : 0}}mins</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// components
import ZlrTitle from '_c/title/title'
import { getTimesheetMaterialSchedule } from '@/api/timesheet'
export default {
  name: '',
  props: ['type'],
  components: {
    ZlrTitle
  },
  data () {
    return {
      scheduleTime: {}
    }
  },
  computed: {
    moduleName () {
      return this.type === 'RL' ? 'MODULE_6' : 'MODULE_5'
    }
  },
  mounted () {
    this.getTimesheetMaterialSchedule()
  },
  methods: {
    getTimesheetMaterialSchedule () {
      getTimesheetMaterialSchedule({
        menteeNum: this.$route.params.id,
        module: this.type === 'RL' ? 'MODULE_6' : 'MODULE_5'
      }).then(res => {
        this.scheduleTime = res.data.model
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    }
  }
}
</script>
<style lang='less' scoped>
.cv-rl-note {
  margin-top: 44px;
  &-item {
    margin-bottom: 8px;
    span {
      display: inline-block;
      line-height: 24px;
      color: rgba(0, 0, 0, 0.85);
    }
    span:first-child {
      width: 544px;
      margin-right: 16px;
      text-align: right;
    }
    span:last-child {
      width: 544px;
    }
  }
}
</style>
